export const SEARCH_TYPE = 'mealDeal';

export const INVALID_SLOT_CAUSE = Symbol('INVALID_SLOT_CAUSE');
export const ENDING_SOON_CAUSE = Symbol('ENDING_SOON_CAUSE');
export const ENDING_TODAY_CAUSE = Symbol('ENDING_TODAY_CAUSE');
export const INVALID_BRANCH_CAUSE = Symbol('INVALID_BRANCH_CAUSE');
